<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        Coding is really important when it comes to programming and software development. When
        software developers write code, they issue instructions to a computer and tell it which
        actions to perform and in what order.
      </p>
      <p class="mb-5">Now you will have a go at coding yourself by creating a short animation!</p>
      <p class="mb-5">
        <strong>Step 1:</strong> Click on this link:
        <a href="https://scratch.mit.edu/projects/editor/?tutorial=getStarted" target="_blank"
          >Scratch</a
        >
        - it will take you to a website called Scratch
      </p>
      <p class="mb-5">
        <strong>Step 2:</strong> Once you are there, click ‘play’ on the tutorial and watch it
      </p>
      <centered-image-wrapper
        :image="image1"
        classes="2/3"
        alt="Screenshot of the Scratch editor with the Getting Started tutorial video open in the middle of the screen, showing a play button. The Motion blocks palette is on the left, the stage with the Scratch cat sprite is on the right, and the Tutorials button is in the top menu bar."
      />

      <p class="mb-5">
        <strong>Step 3:</strong> After you’ve watched the tutorial, click on the tutorial button at
        the top next to the lightbulb and click on the square ‘animate a character’
      </p>
      <p class="mb-5"><strong>Step 4:</strong> Watch the tutorial ‘animate a character’.</p>
      <p class="mb-5">
        <strong>Step 5:</strong> Now you can select a background and then select a ‘sprite’ you
        would like to animate - just like in the tutorial.
      </p>
      <p class="mb-5">
        <strong>Step 6:</strong> Next, try to get your sprite to move in a
        <strong>square</strong> by dragging and dropping the commands on the left over to the right.
        Don’t worry if it takes a few times.
      </p>
      <p class="mb-5">
        <strong>Step 7:</strong> After getting to grips with the sprite moving, you are going to
        make it speak! Get your sprite to say “<strong>I’m doing a great job</strong>”
      </p>
      <p class="mb-5">
        <strong>Step 8:</strong> Take a screen shot of your work and upload. Then give yourself a
        pat on the back, you have created your very own short animation using coding!
      </p>
      <centered-image-wrapper
        :image="image2"
        classes="2/3"
        alt="Screenshot of the Scratch editor showing blocks being dragged from the palette on the left into the code area. The code area contains a script: move 10 steps, then repeat 10 containing turn 15 degrees. A start sound Meow block is being dragged across."
      />

      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="media"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      image1: require('@/assets/images/experiences/developer/a2_1.png'),
      image2: require('@/assets/images/experiences/developer/a2_2.png'),
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
